// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/dashboard","name":"dashboard","icon":"dashboard","parentId":"ant-design-pro-layout","id":"3"},"4":{"path":"/garbage-room/:id","name":"garbageRoom","icon":"home","hideInMenu":true,"parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/debug-user-info","name":"debugUserInfo","icon":"bug","hideInMenu":true,"parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/","redirect":"/dashboard","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"*","layout":false,"id":"7"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__dashboard__index" */'@/pages/dashboard/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__garbage-room__index" */'@/pages/garbage-room/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__DebugUserInfo" */'@/pages/DebugUserInfo.tsx')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'D:/software/VueProject/demo/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
